import React from 'react'

import { AppSvg, Button, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { useIntl } from 'react-intl'
import { GetProducts } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { globalLang } from '~globalLang'

interface Props {
    onClose: () => void
    product?: GetProducts
}

function Content({ onClose, product }: Props) {
    const intl = useIntl()

    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    return (
        <ModalView
            img={
                <div className={s.icon}>
                    <AppSvg svgName={newIcons.ic80Error} size={80} path="new-icons" />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.title} />}
            subtitle={<FormattedHTMLMessage {...lang.subtitle} className={s.subtitle} />}
            dataPointer="issues_modal"
        >
            <div className={s.content}>
                {product?.issues?.map((issue, i) => (
                    <div key={i} className={s.row}>
                        <div className={s.title}>
                            {issue?.title?.key && (
                                <FormattedHTMLMessage
                                    id={issue?.title?.key || ''}
                                    defaultMessage={issue?.title?.fallback || ''}
                                />
                            )}
                        </div>
                        <div className={s.value}>
                            {issue?.value?.key && (
                                <FormattedHTMLMessage
                                    id={issue?.value?.key || ''}
                                    defaultMessage={issue?.value?.fallback || ''}
                                />
                            )}
                        </div>
                    </div>
                ))}
            </div>
            <div className={s.button}>
                <Button dataPointer="ok" size="l" onClick={onClose} fullWidth>
                    <FormattedHTMLMessage {...lang.ok} />
                </Button>
                <Button dataPointer="contact" size="l" mode="primary" href={supportLink} role="anchor" fullWidth>
                    <FormattedHTMLMessage {...lang.contact} />
                </Button>
            </div>
        </ModalView>
    )
}

export default Content
